import { makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { CORPORATE_COLORS } from '@Ui/theme/colors/corporate';
import React from 'react';

import { infoIcon } from '../../assets';
import { Text, TEXT_TYPES, TEXT_VARIANTS } from '../../atoms/Text';
import { AlertProps } from './PrimaryAlert.types';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'start',
    gap: theme.spacing(1.5),
    backgroundColor: CORPORATE_COLORS.BACKGROUND_SECONDARY_LIGHT,
    border: 0,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderRadius: theme.spacing(2)
  },

  textStyle: {
    lineHeight: '1.5'
  }
}));

const PrimaryAlert = ({ text, style, showIcon = false, className, ...props }: AlertProps): React.ReactElement => {
  const classes = useStyles();

  return (
    <Alert
      severity="info"
      variant="outlined"
      className={[classes.root, className].join(' ')}
      icon={showIcon && <img className="u-margin--right u-margin--bottom@small-tiny" src={infoIcon} />}
      {...props}
    >
      <Text className={classes.textStyle} text={text} type={TEXT_TYPES.PRIMARY} variant={TEXT_VARIANTS.BODY1} />
    </Alert>
  );
};

export { PrimaryAlert };
